import React, { memo } from 'react';
import { useState } from 'react';

import { TvIcon } from '@heroicons/react/24/outline';

import PremiumIcon from './PremiumIcon';
import TutorialModal from './TutorialModal';

interface GenericBannerProps {
  className?: string;
  content: React.ReactNode | string;
  link?: string;
  showTutorial?: boolean;
  title: string;
  isPremium?: boolean;
  variation?: string;
}

function GenericBanner(props: GenericBannerProps) {
  const {
    title,
    content,
    className,
    showTutorial = false,
    isPremium = false,
    variation,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="relative h-auto w-full justify-items-center rounded-2xl bg-[url('/images/floaties.svg'),linear-gradient(to_right,rgba(56,125,253,.9),rgba(84,223,255,1))] bg-cover p-4">
      <div className="max-w-xl items-center justify-items-center text-center text-white">
        <div className="flex flex-row items-center gap-3">
          {isPremium && (
            <div className="flex items-center justify-center rounded-full bg-white p-1">
              <PremiumIcon className="h-6 w-6 fill-[#FFB743]" />
            </div>
          )}
          <p className="py-3 text-3xl font-bold tracking-tight">{title}</p>
        </div>
        <p className="mt-2 text-lg leading-relaxed">{content}</p>
      </div>
      {showTutorial ? (
        <>
          <button
            className="group absolute top-4 right-4 cursor-pointer"
            onClick={handleOpenModal}
          >
            <div className="flex">
              <div
                className={`flex items-center rounded-lg bg-white px-2 py-1 ${className}`}
              >
                <TvIcon
                  className={
                    'h-5 transform text-blue-500 transition-transform duration-200 group-hover:scale-110'
                  }
                ></TvIcon>
                <span className="hidden bg-gradient-to-r from-[#1F8DF4] to-[#6CC1D4] bg-clip-text pl-1 text-base font-semibold leading-6 text-transparent sm:block">
                  See How it Works!
                </span>
              </div>
            </div>
          </button>
          <TutorialModal
            isOpen={isModalOpen}
            title={title}
            variation={variation}
            onClose={handleCloseModal}
          />
        </>
      ) : null}
    </div>
  );
}

export default memo(GenericBanner);
